import { render } from "./top-feature.vue?vue&type=template&id=4a44c054"
import script from "./top-feature.vue?vue&type=script&lang=js"
export * from "./top-feature.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__